<template>
  <section>
    <v-row>
      <v-col cols="12">
        <h3>Datos generales del evaluador</h3>
      </v-col>
      <v-col cols="4">
        <BaseTextInput label="Nombre Completo" :value="getFullName(personal)" readonly />
      </v-col>
      <v-col cols="4">
        <BaseTextInput label="Teléfono" :value="personal.Contacto?.telefonoCelular ?? ''" readonly />
      </v-col>
      <v-col cols="4">
        <BaseTextInput label="E-mail" :value="personal.Contacto?.correoElectronico ?? ''" readonly />
      </v-col>
      <v-col cols="4">
        <BaseTextInput label="Puesto" :value="personal.CatPuestoDependencia?.catPuesto?.title ?? ''" readonly />
      </v-col>
      <v-col cols="4">
        <BaseTextInput label="Adscripción" :value="personal.CatArea?.nombre ?? ''" readonly />
      </v-col>
      <v-col cols="4">
        <BaseTextInput label="Institución" value="SECRETARÍA DE SEGURIDAD CIUDADANA" readonly />
      </v-col>
    </v-row>
  </section>
</template>

<script>
import BaseTextInput from '@src/components/base/BaseTextInput.vue'

export default {
  components: { BaseTextInput },

  props: {
    personal: {
      type: Object,
      required: true,
    },
  },
}
</script>
